import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import {
  faCircleCheck,
  faCircleDot,
  faGraduationCap,
  faUser,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { Row, Col } from "react-bootstrap";
import { useEffect, useState, useContext } from "react";
import { M1_StageStatuses } from "../../Constants";
import UserContext from "../../Contexts/UserContext";

function ProgressInfo() {

  const [stepObj, setStepObj] = useState();
  const { user, setUser } = useContext(UserContext);

  useEffect(() => {
    let stepObjHelper = Object.keys(M1_StageStatuses).find(
      (status) =>
        M1_StageStatuses[status].range.includes(user?.currentStep)
    );

    !!stepObjHelper && setStepObj(stepObjHelper);
  }, [user])

  const renderMobileView = () => {
    return (
      <Row className="px-0 mt-0 mb-2 progress-info-mobile">
        <Col xs={"auto"}>
          <FontAwesomeIcon
            icon={faCheck}
            className="progress-point-icon progress-point-side-icon"
          />
        </Col>
        <Col>
          <hr className="progress-point-hr" />
        </Col>
        <Col xs={"auto"} className="text-center d-flex">
          <FontAwesomeIcon icon={faUser} className="progress-point-icon" />
          <div className="progress-point-main-text d-inline-block">{M1_StageStatuses[stepObj].description}</div>
        </Col>
        <Col>
          <hr className="progress-point-hr" />
        </Col>
        <Col xs={"auto"}>
          <FontAwesomeIcon
            icon={faGraduationCap}
            className="progress-point-icon progress-point-side-icon"
          />
        </Col>
      </Row>
    );
  };

  const renderPoints = () => {
    let isMainRendered = false;

    return (
      <>
        {Object.keys(M1_StageStatuses)
          .map((key) => {
            if (!user.isSecondOrderAvailable && (key === 'DevelopmentGoalv2' || key === 'Contractv2')) {
              return;
            }
            if (key === stepObj) {
              isMainRendered = true;
              return renderCurrentPoint(M1_StageStatuses[key].description);
            }

            return !isMainRendered
              ? renderCompletedPoint(M1_StageStatuses[key].description)
              : renderWaitingPoint(M1_StageStatuses[key].description);
          })}
      </>
    );
  };


  const renderDesktopView = () => {
    return (
      <>
        <div className="home-header my-2 progress-info-desktop">
          <h5 className="mb-4 text-uppercase">
            <b>Sprawdź gdzie jesteś:</b>
          </h5>
        </div>
        <div className="progress-info-desktop">
          {renderPoints()}
        </div>
      </>
    );
  };

  const renderCompletedPoint = (text) => {
    return (
      <p className="progress-point">
        <FontAwesomeIcon
          icon={faCircleCheck}
          color="var(--app-color-primary)"
          className="mt-2"
        />
        <span className="ml-3 mt-1">{text}</span>
      </p>
    );
  };

  const renderWaitingPoint = (text) => {
    return (
      <p className="progress-point">
        <FontAwesomeIcon
          icon={faCircle}
          color="var(--app-color-primary)"
          className="mt-2"
        />
        <span className="ml-3 mt-1">{text}</span>
      </p>
    );
  };

  const renderCurrentPoint = (text) => {
    return (
      <p className="progress-point progress-point-current">
        <FontAwesomeIcon
          icon={faCircleDot}
          color="var(--app-color-secondary)"
          className="mt-2"
        />
        <span className="ml-3 mt-1">
          <b>{text}</b>
        </span>
      </p>
    );
  };

  return (
    <>
      {!!stepObj && (<>
        {renderDesktopView()}
        {renderMobileView()}
      </>)}
    </>
  );
}

export default ProgressInfo;
